import React, {Component} from 'react';

import {withRouter} from 'react-router-dom';
import REST from '../Shared/REST';
import '../assets/custom.css';

import logo from '../assets/images/logo_avenuepm.png';
import logo_picturenaming from '../assets/images/app-picturenaming.png';
import logo_kidspeak from '../assets/images/logo_kidspeak.png';
import logo_wordmark from '../assets/images/logo_wordmark.png';
import logo_wordmark2 from '../assets/images/logo_wordmark2.png';
import logo_slashtest from '../assets/images/logo_slashtest.png';
import logo_wordsignsay from '../assets/images/app-wordsignsay.png';
import logo_kidsign from '../assets/images/app-kidsignsay.png';
import logo_copyright from '../assets/images/app-copyright.png';
import logo_maze from '../assets/images/logo_maze.png';
import badge1 from '../assets/images/badge_1.png';
import badge2 from '../assets/images/badge_2.png';
import badge3 from '../assets/images/badge_3.png';
import badge4 from '../assets/images/badge_4.png';
import badge5 from '../assets/images/badge_5.png';
import badge6 from '../assets/images/badge_6.png';
import badge7 from '../assets/images/badge_7.png';

import Helpers from "../Shared/Helpers";
import {updateFirstLogin, updateStudentAppsStatus} from "../StudentsComponent/actions";
import {connect} from "react-redux";
import MyProfileComponent from "./MyProfile";
import Footer from "../Shared/Footer";
import {updateAppStates, updateStudentAccountTab} from "./actions";
import DialogBox from "../Shared/DialogBox";
import {isTablet} from "react-device-detect";
import {isMobile} from 'react-device-detect';

let addClassInstruction = null;
let addStudentInstruction = null;
let PNInstruction = null;
let WSSInstruction = null;
let CopyrightInstruction = null;
let KidsignInstruction = null;
let KidspeakInstruction = null;

class MainStudentComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {activeTab: this.props.tabNum, bestScores:[]};
        this.myProfile = this.myProfile.bind(this);
        this.myTasks = this.myTasks.bind(this);
        this.logout = this.logout.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }

    componentDidMount() {
        Helpers.authorize(this);
        REST.getStudentAppStatus().then(async(res)=>{
            await this.props.updateStudentAppStatus(res.body);
            let {allowedApps, filteredApps, finishedApps} = Helpers.filterApps(this.props.studentUser,this.props.apps);
            await this.props.updateAppStates({
                allowedApps:allowedApps,
                filteredApps:filteredApps,
                finishedApps:finishedApps
            });
            await this.setState({bestScores: res.body.bestScores})
        });
    }

    handleSelect = (selected) => {
        this.props.updateStudentAccountTab(selected);
        this.setState({activeTab: selected});
    };

    logout() {
        this.props.updateStudentAccountTab(1);
        this.setState({activeTab: 3});
        REST.logout().then((response) => {
            if (response.success) {
                if(localStorage.getItem('addClass') === 'hide'){
                    addClassInstruction = localStorage.getItem('addClass');
                }
                if(localStorage.getItem('addStudent') === 'hide'){
                    addStudentInstruction = localStorage.getItem('addStudent');
                }
                localStorage.removeItem('token');
                if(addClassInstruction !== null){
                    localStorage.setItem('addClass',addClassInstruction);
                }
                if(addStudentInstruction !== null){
                    localStorage.setItem('addStudent',addStudentInstruction);
                }
                this.props.persistor.purge();
                this.props.history.push("/login");
            }
        }, (error) => {
            console.log('Error', error);
            localStorage.removeItem('token');
            localStorage.clear();
            this.props.persistor.purge();
            this.props.history.push("/login");
        });
    }

    myTasks(event) {
        this.setState({activeTab: 1});
        this.props.updateStudentAccountTab(1);
        event.preventDefault();
    }

    myProfile(event) {
        this.setState({activeTab: 2});
        this.props.updateStudentAccountTab(2);
        event.preventDefault();
    }

    render() {
        return (
            <div>
                <nav id="header" className="navbar">
                    <div id="header-container" className="container navbar-container">
                        <div className="navbar-header fl">
                            <a id="brand" className="navbar-brand" href="/">
                                <img src={logo} alt="AvenuePM" border="0"/>
                            </a>
                        </div>
                        <div className="navbar fr">
                            <div className="navbar-collapse" id="bs-example-navbar-collapse-1">
                                <ul className="nav navbar-nav">
                                    <li><a onClick={this.myTasks}
                                           className={this.state.activeTab === 1 ? "handBtn active" : "handBtn"}><span>My Tasks</span></a>
                                    </li>
                                    <li><a onClick={this.myProfile}
                                           className={this.state.activeTab === 2 ? "handBtn active" : "handBtn"}><span>My Progress</span></a>
                                    </li>
                                    <li><a onClick={this.logout}
                                           className={this.state.activeTab === 3 ? "handBtn active" : "handBtn"}><span>Logout</span></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </nav>
                {this.state.activeTab === 1 ? <MyTasksComponent bestScores={this.state.bestScores} {...this.props}/> : null}
                {this.state.activeTab === 2 ? <MyProfileComponent/> : null}
                <Footer/>
            </div>
        );
    }
}

class MyTasksComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {modalDialog:false, popupSurvey:true,responseContent:''};
        this.handleSurveyBack = this.handleSurveyBack.bind(this);
        this.handleMaze = this.handleMaze.bind(this);
        this.handleSlashTest = this.handleSlashTest.bind(this);
        this.handleWordMark = this.handleWordMark.bind(this);
        this.handleWordMark2 = this.handleWordMark2.bind(this);
        this.handleKidSpeak = this.handleKidSpeak.bind(this);
        this.handlePictureNaming = this.handlePictureNaming.bind(this);
        this.handleCopyRight = this.handleCopyRight.bind(this);
        this.handleWordSignSay = this.handleWordSignSay.bind(this);
        this.handleKidSign = this.handleKidSign.bind(this);
    }

    async handleSurveyBack(){
    }

    handleMaze(event) {
        event.preventDefault();
        if(!this.props.appStates.filteredApps.includes("maze")){
            return null;
        }else {
            this.props.history.push('/student/tasks/maze');
        }
    }

    handleSlashTest(event) {
        event.preventDefault();
        if(!this.props.appStates.filteredApps.includes("slash")) {
            return null;
        }else {
            this.props.history.push('/student/tasks/slashtest');
        }
    }

    handleWordMark(event) {
        event.preventDefault();
        if(!this.props.appStates.filteredApps.includes("wordmark")) {
            return null;
        } else if(this.props.apps.wordMarkScores.filter(function(x){return x.gradingDate==null}).length >2){
            this.setState({
                modalDialog: true,
                responseContent:'You have 3 WordMark tasks waiting to be scored. You can continue after they are scored by your teacher.'
            });
        }else {
            this.props.history.push('/student/tasks/wordmark');
        }
    }

    handleWordMark2(event) {
        event.preventDefault();
        this.props.history.push('/student/tasks/wordmark2');
    }

    handleKidSpeak(event) {
        event.preventDefault();
        if(!this.props.appStates.filteredApps.includes("kidspeak")) {
            return null;
        } else if(this.props.apps.kidSpeakScores.filter(function(x){return x.gradingDate==null}).length >2){
            this.setState({
                modalDialog: true,
                responseContent:'You have 3 KidSpeak tasks waiting to be scored. You can continue after they are scored by your teacher.'
            });
        }else {
            this.props.history.push('/student/apps/kidspeak');
        }
    }

    handlePictureNaming(event) {
        event.preventDefault();
        if(!this.props.appStates.filteredApps.includes("picturenaming")) {
            return null;
        } else if(this.props.apps.pictureNamingScores.filter(function(x){return x.gradingDate==null}).length >2){
            this.setState({
                modalDialog: true,
                responseContent:'You have 3 Picture Naming tasks waiting to be scored. You can continue after they are graded.'
            });
        }else {
            this.props.history.push('/student/apps/picturenaming');
        }
    }

    handleCopyRight(event) {
        event.preventDefault();
        if(!this.props.appStates.filteredApps.includes("copyright")) {
            return null;
        } else if(this.props.apps.copyRightScores.filter(function(x){return x.gradingDate==null}).length >2){
            this.setState({
                modalDialog: true,
                responseContent:'You have 3 CopyRight tasks waiting to be scored. You can continue after they are scored by your teacher.'
            });
        }else {
            this.props.history.push('/student/apps/copyright');
        }
    }

    handleKidSign(event) {
        event.preventDefault();
        if(!this.props.appStates.filteredApps.includes("kidsign")) {
            return null;
        } else if(this.props.apps.kidSignScores.filter(function(x){return x.gradingDate==null}).length >2){
            this.setState({
                modalDialog: true,
                responseContent:'You have 3 KidSign tasks waiting to be scored. You can continue after they are scored by your teacher.'
            });
        }else {
            this.props.history.push('/student/apps/kidsign');
        }
    }

    handleWordSignSay(event) {
        event.preventDefault();
        if(!this.props.appStates.filteredApps.includes("wordsignsay")) {
            return null;
        } else if(this.props.apps.wordSignSayScores.filter(function(x){return x.gradingDate==null}).length >2){
            this.setState({
                modalDialog: true,
                responseContent:'You have 3 Word Sign/Say tasks waiting to be scored. You can continue after they are scored by your teacher.'
            });
        }else {
            this.props.history.push('/student/apps/wordsignsay');
        }
    }

    render() {

        let {allowedApps, filteredApps, finishedApps} = this.props.appStates ? this.props.appStates : {
            allowedApps: [],
            filteredApps: [],
            finishedApps: []
        };
        return (
            <div className="section bgGrey">
                <div className="container">
                    <DialogBox warning notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                    <DialogBox surveyModal app={'Homepage'} userId={this.props.studentUser.id} active={true} surveyBack={this.handleSurveyBack}/>
                    <div className="row">
                        <div className="col-lg-12">
                            <h2 className="tc">MY TASKS: {this.props.studentUser.firstname+' '+this.props.studentUser.lastname}</h2>
                            {/*<p className="tc">(Click on each app icon to start a new task)</p>*/}
                            <ul className="nav nav-pills pill-sm">
                                {allowedApps.includes("picturenaming") ?
                                    <li style={{margin:10}}>
                                            {this.props.bestScores.pnLevel > 3 ?

                                                <a data-toggle="pill"
                                                   style={{cursor: 'not-allowed'}}
                                                >
                                                <img src={logo_picturenaming} className="ico-l" alt="Picture Naming"
                                                     style={{height:75,filter: filteredApps.includes("picturenaming") ? "none" : "grayscale(100%)", opacity: filteredApps.includes("picturenaming") ? "1" : "0.5"}}
                                                     border="0"/>
                                                    <img src={badge7} style={{position:'absolute', right:-20, bottom:-20}} />
                                                </a>

                                            :
                                                <a data-toggle="pill"
                                                onClick={this.handlePictureNaming}
                                                style={{cursor: filteredApps.includes("picturenaming") ? "pointer" : "default"}}
                                                >
                                                <img src={logo_picturenaming} className="ico-l" alt="Picture Naming"
                                                     style={{height:75,filter: filteredApps.includes("picturenaming") ? "none" : "grayscale(100%)", opacity: filteredApps.includes("picturenaming") ? "1" : "0.5"}}
                                                     border="0"/>
                                                </a>
                                            }
                                    </li>
                                    : null
                                }
                                {allowedApps.includes("wordsignsay") ?
                                    <li style={{margin:10}}>
                                            {this.props.bestScores.wssLevel > 1 ?
                                                <a data-toggle="pill"
                                                   style={{cursor: "not-allowed"}}
                                                >
                                                    <img src={logo_wordsignsay} className="ico-l" alt="Word Sign/Say"
                                                         style={{
                                                             height: 75,
                                                             filter: filteredApps.includes("wordsignsay") ? "none" : "grayscale(100%)",
                                                             opacity: filteredApps.includes("wordsignsay") ? "1" : "0.5"
                                                         }}
                                                         border="0"/>
                                                    <img src={badge4} style={{position:'absolute', right:-20, bottom:-20}} />
                                                </a>
                                                :
                                                <a data-toggle="pill"
                                                   onClick={this.handleWordSignSay}
                                                   style={{cursor: filteredApps.includes("wordsignsay") ? "pointer" : "default"}}
                                                >
                                                <img src={logo_wordsignsay} className="ico-l" alt="Word Sign/Say"
                                                     style={{
                                                         height: 75,
                                                         filter: filteredApps.includes("wordsignsay") ? "none" : "grayscale(100%)",
                                                         opacity: filteredApps.includes("wordsignsay") ? "1" : "0.5"
                                                     }}
                                                     border="0"/>
                                                </a>
                                            }
                                    </li>
                                    : null
                                }
                                {allowedApps.includes("copyright") ?
                                    <li style={{margin:10}}>
                                            {this.props.bestScores.crLevel > 6 ?
                                                <a data-toggle="pill"
                                                   style={{cursor: "not-allowed"}}
                                                >
                                                <img src={logo_copyright} className="ico-l" alt="CopyRight" border="0"
                                                     style={{
                                                         height: 75,
                                                         filter: filteredApps.includes("copyright") ? "none" : "grayscale(100%)",
                                                         opacity: filteredApps.includes("copyright") ? "1" : "0.5"
                                                     }}
                                                />
                                                    <img src={badge1} style={{position:'absolute', right:-20, bottom:-20}} />
                                                </a>
                                                :
                                                <a data-toggle="pill"
                                                   onClick={this.handleCopyRight}
                                                   style={{cursor: filteredApps.includes("copyright") ? "pointer" : "default"}}
                                                >
                                                <img src={logo_copyright} className="ico-l" alt="CopyRight" border="0"
                                                     style={{
                                                         height: 75,
                                                         filter: filteredApps.includes("copyright") ? "none" : "grayscale(100%)",
                                                         opacity: filteredApps.includes("copyright") ? "1" : "0.5"
                                                     }}
                                                />
                                                </a>
                                            }
                                    </li>
                                    : null
                                }
                                {allowedApps.includes("slash") ?
                                    <li style={{margin:10}}>
                                            {this.props.bestScores.slashLevel > 8 ?
                                                <a data-toggle="pill"
                                                   style={{cursor: "not-allowed"}}
                                                >
                                                    <img src={logo_slashtest} className="ico-l" alt="Slashtest" border="0"
                                                         style={{
                                                             height: 75,
                                                             filter: filteredApps.includes("slash") ? "none" : "grayscale(100%)",
                                                             opacity: filteredApps.includes("slash") ? "1" : "0.5"
                                                         }}
                                                    />
                                                    <img src={badge3} style={{position:'absolute', right:-20, bottom:-20}} />
                                                </a>
                                                :
                                                <a data-toggle="pill"
                                                   onClick={this.handleSlashTest}
                                                   style={{cursor: filteredApps.includes("slash") ? "pointer" : "default"}}
                                                >
                                                <img src={logo_slashtest} className="ico-l" alt="Slashtest" border="0"
                                                     style={{
                                                         height: 75,
                                                         filter: filteredApps.includes("slash") ? "none" : "grayscale(100%)",
                                                         opacity: filteredApps.includes("slash") ? "1" : "0.5"
                                                     }}
                                                />
                                                </a>
                                            }
                                    </li>
                                    : null
                                }
                                {allowedApps.includes("kidspeak") ?
                                    <li style={{margin:10}}>
                                            {this.props.bestScores.ksLevel > 12 ?
                                                <a data-toggle="pill"
                                                   style={{cursor: "not-allowed"}}
                                                >
                                                    <img src={logo_kidspeak} className="ico-l" alt="Kid Speak" border="0"
                                                         style={{
                                                             height: 75,
                                                             filter: filteredApps.includes("kidspeak") ? "none" : "grayscale(100%)",
                                                             opacity: filteredApps.includes("kidspeak") ? "1" : "0.5"
                                                         }}
                                                    />
                                                    <img src={badge2} style={{position:'absolute', right:-20, bottom:-20}} />
                                                </a>
                                                :
                                                <a data-toggle="pill"
                                                   onClick={this.handleKidSpeak}
                                                   style={{cursor: filteredApps.includes("kidspeak") ? "pointer" : "default"}}
                                                >
                                                <img src={logo_kidspeak} className="ico-l" alt="Kid Speak" border="0"
                                                     style={{
                                                         height: 75,
                                                         filter: filteredApps.includes("kidspeak") ? "none" : "grayscale(100%)",
                                                         opacity: filteredApps.includes("kidspeak") ? "1" : "0.5"
                                                     }}
                                                />
                                                </a>
                                            }
                                    </li>
                                    : null
                                }
                                {allowedApps.includes("maze") ?
                                    <li style={{margin:10}}>
                                            {this.props.bestScores.mazeLevel > 12 ?
                                                <a data-toggle="pill"
                                                   style={{cursor: "not-allowed"}}
                                                >
                                                    <img src={logo_maze} className="ico-l" alt="Maze" border="0"
                                                         style={{
                                                             height: 75,
                                                             filter: filteredApps.includes("maze") ? "none" : "grayscale(100%)",
                                                             opacity: filteredApps.includes("maze") ? "1" : "0.5"
                                                         }}
                                                    />
                                                    <img src={badge5} style={{position:'absolute', right:-20, bottom:-20}} />
                                                </a>
                                                :
                                                <a data-toggle="pill"
                                                   onClick={this.handleMaze}
                                                   style={{cursor: filteredApps.includes("maze") ? "pointer" : "default"}}
                                                >
                                                <img src={logo_maze} className="ico-l" alt="Maze" border="0"
                                                     style={{
                                                         height: 75,
                                                         filter: filteredApps.includes("maze") ? "none" : "grayscale(100%)",
                                                         opacity: filteredApps.includes("maze") ? "1" : "0.5"
                                                     }}
                                                />
                                                </a>
                                            }
                                    </li>
                                    : null
                                }
                                {allowedApps.includes("kidsign") ?
                                    <li style={{margin:10}}>
                                            {this.props.bestScores.kssLevel > 12 ?
                                                <a data-toggle="pill"
                                                   style={{cursor: "not-allowed"}}
                                                >
                                                    <img src={logo_kidsign} className="ico-l" alt="KidSign" border="0"
                                                         style={{height:75,filter: filteredApps.includes("kidsign") ? "none" : "grayscale(100%)", opacity: filteredApps.includes("kidsign") ? "1" : "0.5"}} />
                                                    <img src={badge6} style={{position:'absolute', right:-20, bottom:-20}} />
                                                </a>
                                                :
                                                <a data-toggle="pill"
                                                   onClick={this.handleKidSign}
                                                   style={{cursor: filteredApps.includes("kidsign") ? "pointer" : "default"}}
                                                >
                                                <img src={logo_kidsign} className="ico-l" alt="KidSign" border="0"
                                                     style={{height:75,filter: filteredApps.includes("kidsign") ? "none" : "grayscale(100%)", opacity: filteredApps.includes("kidsign") ? "1" : "0.5"}} />
                                                </a>
                                            }
                                    </li>
                                    : null
                                }
                                {allowedApps.includes("wordmark")?
                                    <li style={{margin:10}}>
                                        <a data-toggle="pill"
                                           onClick={this.handleWordMark}
                                           style={{cursor: filteredApps.includes("wordmark") ? "pointer" : "default"}}
                                        >
                                            <img src={logo_wordmark} className="ico-l" alt="Word Mark" border="0"
                                                 style={{height:75,filter: filteredApps.includes("wordmark") ? "none" : "grayscale(100%)", opacity: filteredApps.includes("wordmark") ? "1" : "0.5"}}
                                            />
                                        </a>
                                    </li>
                                    : null
                                }
                                <li style={{margin:10}}>
                                    <a data-toggle="pill"
                                       onClick={this.handleWordMark2}
                                       style={{cursor:"pointer"}}
                                    >
                                        <img src={logo_wordmark2} className="ico-l" alt="Word Mark" border="0"
                                             style={{height:75,filter: "none", opacity: "1" }}
                                        />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const Tasks = withRouter(MyTasksComponent);

class MyHistoryComponent extends Component {
    render() {
        return (
            <h1 className="tc">My History Component</h1>
        )
    }
}

const bindActionToProps = dispatch => {
    return {
        updateStudentAppStatus: async(results) => await dispatch(updateStudentAppsStatus(results)),
        updateStudentAccountTab:async(tabNum) => await dispatch(updateStudentAccountTab(tabNum)),
        updateAppStates:async(appStates) => await dispatch(updateAppStates(appStates))
    };
};


const mapStateToProps = state => ({
    apps:state.studentReducer.apps,
    tabNum: state.studentReducer.tabNum,
    studentUser: state.studentReducer.studentUser,
    appStates: state.studentReducer.appStates
});


export default connect(mapStateToProps,bindActionToProps)(withRouter(MainStudentComponent));



// WEBPACK FOOTER //
// ./src/StudentsComponent/Main.js